import React, { useState } from "react";
import "./Tooltip.css";

const CustomTooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <span
        className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={() => showTip()}
      onMouseLeave={() => hideTip()}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || "top"}`}>
          {/* Content */}
          {props.content}
        </div>
      )}
    </span>
  );
};

export default CustomTooltip;
